var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKosova(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 4,
    width: 30,
    height: 24,
    rx: 4,
    ry: 4,
    fill: "#2b48a1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27,4H5c-2.209,0-4,1.791-4,4V24c0,2.209,1.791,4,4,4H27c2.209,0,4-1.791,4-4V8c0-2.209-1.791-4-4-4Zm3,20c0,1.654-1.346,3-3,3H5c-1.654,0-3-1.346-3-3V8c0-1.654,1.346-3,3-3H27c1.654,0,3,1.346,3,3V24Z",
    opacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "1705926025363-6707604_path26",
    d: "M16.156,12.199c-.057,1.364,1.363,.39,1.832,1.489,.487,.442,.644,1.522,1.729,1.459-.162,.783-.33,.978,.564,1.156,.444-.261,.471,.228,.764,.383,.249-.063,.732-.298,.865,.191-.371,.914-.734,1.954-1.307,2.445-1.139-.027,1.325,1.149-.422,.914-.24-.582-.677,.28-1.046,.362-.096,1.024-.689,1.254-1.146,.171-3.899,.52-1.321,2.439-3.4,2.616-.614-5.252-1.701-2.347-2.495-4.607-.124-.516-.581-.74-.935-1.106,.255-.676,.079-.865-.583-1.136-.063-.619,.712-.87,1.207-.473,.435-.136,.606-.626,1.228-.654,1.024,.037,.741-.26,.884-.976,.512-.414,.862-.237,.986-.935,.495-.172-.864-.71-.11-1.016,.46-.079,1.063-.794,1.388-.281",
    fill: "#c8a75e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "1705926025363-6707604_polygon37",
    d: "M17.713,9.471l-.278-.855-.275,.855h-.9l.728,.529-.278,.855,.724-.529,.728,.529-.278-.855,.728-.529h-.9Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "1705926025363-6707604_polygon39",
    d: "M20.542,9.969l-.278-.851-.275,.851h-.9l.728,.529-.278,.855,.724-.529,.728,.529-.278-.855,.728-.529h-.9Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "1705926025363-6707604_polygon41",
    d: "M23.241,10.951l-.275-.851-.278,.851h-.9l.728,.529-.278,.855,.728-.529,.724,.529-.278-.855,.728-.529h-.9Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "1705926025363-6707604_polygon43",
    d: "M14.84,9.471l-.275-.855-.278,.855h-.9l.728,.529-.278,.855,.728-.529,.724,.529-.278-.855,.728-.529h-.9Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "1705926025363-6707604_polygon45",
    d: "M12.011,9.969l-.275-.851-.278,.851h-.9l.728,.529-.278,.855,.728-.529,.724,.529-.278-.855,.728-.529h-.9Z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "1705926025363-6707604_polygon47",
    d: "M9.312,10.951l-.278-.851-.275,.851h-.9l.728,.529-.278,.855,.724-.529,.728,.529-.278-.855,.728-.529h-.9Z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27,5H5c-1.657,0-3,1.343-3,3v1c0-1.657,1.343-3,3-3H27c1.657,0,3,1.343,3,3v-1c0-1.657-1.343-3-3-3Z",
    fill: "#fff",
    opacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKosova);
export default __webpack_public_path__ + "static/media/kosova.b353a53a86caf91fdbf0b328844584a3.svg";
export { ForwardRef as ReactComponent };